import * as angular from 'angular';

class NetworkPointBundleCreateIdentificationCtrl implements ng.IController {
    constructor() {}

    $onInit() {}

    public bundleRequest: BundleChangeRequestDto;
    public isConversationMode: boolean;
    public isInitialMode: boolean;
    public readonly: boolean;
}

angular.module('app').component('pkpNetworkPointBundleCreateIdentification', {
    controller: NetworkPointBundleCreateIdentificationCtrl,
    template:
        require('app/network-point-bundle/network-point-bundle-create-identification.component.html'),
    bindings: {
        readonly: '<',
        isConversationMode: '<',
        isInitialMode: '<',
        form: '=',
        bundleRequest: '='
    }
});
